<template>
  <div class="mask" v-if="showMessageModal || componentShow">
    <section class="message-modal">
      <!-- 成功图标 -->
      <!--      假如是网络异常的图片，有单独的图片宽高-->
      <img
        v-if="options.image"
        :class="['message-logo', { 'connect-error': options.sucImgSrc }]"
        :src="options.sucImgSrc || require('../image/message.svg')"
        alt="success message"
      />
      <!-- 取消图标 -->
      <img
        v-if="options.closeIcon"
        class="message-cancel"
        src="~img/cancel.png"
        alt="cancel button"
        @click="hide"
      />
      <!-- 标题 -->
      <p v-if="options.title" class="message-msg" role="Complete">{{ i18n.t(options.title) }}</p>
      <!-- 描述 -->
      <p
        v-if="options.desc && !options.count && !options.i18nNeed"
        class="message-desc"
        :style="{ marginBottom: options.desc2 ? '24px' : '48px' }"
        role="description"
        v-html="options.desc"
      ></p>
      <p
        v-if="options.desc && !options.count && options.i18nNeed"
        class="message-desc"
        :style="{ marginBottom: options.desc2 ? '24px' : '48px' }"
        role="description"
      >
        {{ i18n.t(options.desc) }}
      </p>
      <p v-if="options.desc2 && !options.count" class="message-desc" role="description">
        {{ i18n.t(options.desc2) }}
      </p>

      <!-- 描述组合 -->
      <div v-if="options.descGroup" class="desc-group">
        <p class="desc-group-head">{{ i18n.t(options.descGroup.desc1) }}</p>
        <ul>
          <li v-for="(desc, index) in options.descGroup.subDesc" :key="index">
            {{ i18n.t(desc) }}
          </li>
        </ul>
        <p class="desc-group-footer">{{ i18n.t(options.descGroup.desc2) }}</p>
      </div>

      <!-- 倒计时 -->
      <p v-if="options.countDescHead" class="message-count" role="description">
        <span v-if="options.countDescHead">{{ i18n.t(options.countDescHead) }}</span>
        <span class="count" v-if="options.currentCount">
          {{ i18n.t(options.currentCount) }}
        </span>
        <span class="count unit" v-if="options.unit">{{ i18n.t(options.unit) }}</span>
        <span v-if="options.countDescFooter">{{ i18n.t(options.countDescFooter) }}</span>
      </p>

      <!-- 按钮 -->
      <div class="message-btn-group">
        <button
          v-if="options.confirmBtn"
          class="message-btn"
          role="button"
          @click="login(options.nextStep)"
        >
          {{ i18n.t(options.confirmBtn) }}
        </button>
        <button v-if="options.cancelBtn" class="message-cancel-btn" role="button" @click="hide">
          {{ i18n.t(options.cancelBtn) }}
        </button>
      </div>
    </section>
  </div>
</template>

<script>
  // 解决获取不到$router的问题
  import router from '@/router';
  import i18n from '@/i18n';

  export default {
    name: 'MessageModal',
    props: {
      // options: {
      //   type: Object,
      //   default: () => {},
      // },
      componentShow: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        i18n,
        showMessageModal: false,
        number: 15,
        currentCount: 0,
        timer: null,
        options: {},
      };
    },

    methods: {
      show(options) {
        this.options = options;
        this.showMessageModal = true;
        // 之后如果需要倒计时的话可以加上
        if (options.count) {
          this.countDown();
        }
      },

      hide() {
        this.showMessageModal = false;

        // 关闭弹窗时执行回调函数
        this.options.callback && this.options.callback();

        // 只有将messageModal当做组件的情况下才生效
        if (this.componentShow) {
          this.$emit('cancel');
        }
      },
      // TODO: 此处逻辑建议再调整下
      login() {
        // 关闭弹窗时执行成功的回调函数
        this.options.successCallback && this.options.successCallback();
        this.hide();

        if (!this.options.justHide) {
          // router.push(nextStep);
          // this.$loginModal.show();
          router.push('/login');
        }

        // 只有将messageModal当做组件的情况下才生效
        if (this.componentShow) {
          this.$emit('confirm');
        }
      },
      countDown() {
        const time = this.options.currentCount;
        if (!this.timer) {
          this.currentCount = time;
          this.timer = setInterval(() => {
            if (this.currentCount > 0 && this.currentCount <= time) {
              // eslint-disable-next-line no-plusplus
              this.options.currentCount = this.currentCount--;
            } else {
              clearInterval(this.timer);
              this.timer = null;
              this.$emit('again');
            }
          }, 1000);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use './index.scss';
  @use './mobile';
</style>
